import { Provider } from "react-redux";
import "react-toastify/dist/ReactToastify.css";
import "./App.css";
import IntlProviderWrapper from "./config/IntlProviderWrapper";
import store from "./config/redux";
import { AuthProvider } from "./routes/AuthProvider";
import ProtectedRoute from "./routes/ProtectedRoute";

function App() {
  return (
    <IntlProviderWrapper>
      <Provider store={store}>
        <AuthProvider>
          <ProtectedRoute />
        </AuthProvider>
      </Provider>
    </IntlProviderWrapper>
  );
}

export default App;
